import { render, staticRenderFns } from "./welcomeAprende.vue?vue&type=template&id=32f4e99b&scoped=true&fluid=true&"
import script from "./welcomeAprende.vue?vue&type=script&lang=js&"
export * from "./welcomeAprende.vue?vue&type=script&lang=js&"
import style0 from "./welcomeAprende.vue?vue&type=style&index=0&id=32f4e99b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4e99b",
  null
  
)

export default component.exports